/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateServerForm,
  CreateServerForm$Outbound,
  CreateServerForm$outboundSchema,
} from "../components/createserverform.js";

export type CreateRemoteMcpServerSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type CreateRemoteMcpServerSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type CreateRemoteMcpServerSecurity = {
  option1?: CreateRemoteMcpServerSecurityOption1 | undefined;
  option2?: CreateRemoteMcpServerSecurityOption2 | undefined;
};

export type CreateRemoteMcpServerRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  createServerForm: CreateServerForm;
};

/** @internal */
export type CreateRemoteMcpServerSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const CreateRemoteMcpServerSecurityOption1$outboundSchema: z.ZodMiniType<
  CreateRemoteMcpServerSecurityOption1$Outbound,
  CreateRemoteMcpServerSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function createRemoteMcpServerSecurityOption1ToJSON(
  createRemoteMcpServerSecurityOption1: CreateRemoteMcpServerSecurityOption1,
): string {
  return JSON.stringify(
    CreateRemoteMcpServerSecurityOption1$outboundSchema.parse(
      createRemoteMcpServerSecurityOption1,
    ),
  );
}

/** @internal */
export type CreateRemoteMcpServerSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const CreateRemoteMcpServerSecurityOption2$outboundSchema: z.ZodMiniType<
  CreateRemoteMcpServerSecurityOption2$Outbound,
  CreateRemoteMcpServerSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function createRemoteMcpServerSecurityOption2ToJSON(
  createRemoteMcpServerSecurityOption2: CreateRemoteMcpServerSecurityOption2,
): string {
  return JSON.stringify(
    CreateRemoteMcpServerSecurityOption2$outboundSchema.parse(
      createRemoteMcpServerSecurityOption2,
    ),
  );
}

/** @internal */
export type CreateRemoteMcpServerSecurity$Outbound = {
  Option1?: CreateRemoteMcpServerSecurityOption1$Outbound | undefined;
  Option2?: CreateRemoteMcpServerSecurityOption2$Outbound | undefined;
};

/** @internal */
export const CreateRemoteMcpServerSecurity$outboundSchema: z.ZodMiniType<
  CreateRemoteMcpServerSecurity$Outbound,
  CreateRemoteMcpServerSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => CreateRemoteMcpServerSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => CreateRemoteMcpServerSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function createRemoteMcpServerSecurityToJSON(
  createRemoteMcpServerSecurity: CreateRemoteMcpServerSecurity,
): string {
  return JSON.stringify(
    CreateRemoteMcpServerSecurity$outboundSchema.parse(
      createRemoteMcpServerSecurity,
    ),
  );
}

/** @internal */
export type CreateRemoteMcpServerRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  CreateServerForm: CreateServerForm$Outbound;
};

/** @internal */
export const CreateRemoteMcpServerRequest$outboundSchema: z.ZodMiniType<
  CreateRemoteMcpServerRequest$Outbound,
  CreateRemoteMcpServerRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    createServerForm: CreateServerForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      createServerForm: "CreateServerForm",
    });
  }),
);

export function createRemoteMcpServerRequestToJSON(
  createRemoteMcpServerRequest: CreateRemoteMcpServerRequest,
): string {
  return JSON.stringify(
    CreateRemoteMcpServerRequest$outboundSchema.parse(
      createRemoteMcpServerRequest,
    ),
  );
}
